import { render, staticRenderFns } from "./HeroPlans.vue?vue&type=template&id=3ed24002&scoped=true&"
import script from "./HeroPlans.vue?vue&type=script&lang=js&"
export * from "./HeroPlans.vue?vue&type=script&lang=js&"
import style0 from "./HeroPlans.vue?vue&type=style&index=0&id=3ed24002&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed24002",
  null
  
)

export default component.exports